module.exports = __webpack_public_path__ + "img/李坚强-4x.2b7442ad.png";